import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import StaffsTable from '../StaffsTable';

const Logistics = ({
  handleViewDetail,
  toggleAddRecord,
  handleDelete,
  searchString,
}) => {
  return (
    <div>
      {' '}
      <ErrorBoundary>
        <StaffsTable
          handleViewDetail={handleViewDetail}
          toggleAddRecord={toggleAddRecord}
          handleDelete={handleDelete}
          searchString={searchString}
          department="LOGISTICS"
        />
      </ErrorBoundary>
    </div>
  );
};

export default Logistics;
